
import { Skeleton } from "@/components/ui/skeleton";
import { motion } from "framer-motion";

const LoadingState = () => (
  <div className="max-w-4xl mx-auto">
    <div className="flex flex-col items-center mb-8">
      <Skeleton className="h-8 w-64 mb-4" />
      <Skeleton className="h-6 w-80 mb-6" />
      
      <motion.div 
        className="w-full h-2 bg-gray-200 rounded-full mb-6"
        animate={{ 
          background: ["#F3F4F6", "#E5E7EB", "#F3F4F6"]
        }}
        transition={{ 
          duration: 1.5, 
          repeat: Infinity 
        }}
      >
        <motion.div 
          className="h-full bg-hero-mid rounded-full"
          animate={{ width: ["0%", "60%", "90%", "100%"] }}
          transition={{ 
            duration: 2, 
            times: [0, 0.4, 0.7, 1], 
            repeat: Infinity 
          }}
        />
      </motion.div>
      
      <div className="w-full space-y-4 mb-8">
        <Skeleton className="h-24 w-full rounded-lg" />
        <Skeleton className="h-24 w-full rounded-lg" />
        <Skeleton className="h-24 w-full rounded-lg" />
      </div>
      
      <div className="w-full flex justify-end">
        <Skeleton className="h-10 w-32 rounded-md" />
      </div>
    </div>
  </div>
);

export default LoadingState;
